import React from 'react';
import { useTranslation } from 'react-i18next';
import { FreshnessThresholds } from '../../utils/scoutingUtils';

interface FreshnessLegendProps {
  thresholds: FreshnessThresholds;
}

const FreshnessLegend: React.FC<FreshnessLegendProps> = ({ thresholds }) => {
  const { t } = useTranslation();
  const { greenDays, yellowDays, greenColor, yellowColor, redColor } = thresholds;

  const items = [
    {
      color: greenColor ?? '#27ae60',
      label: t('dashboard.fresh', { greenDays }),
    },
    {
      color: yellowColor ?? '#f39c12',
      label: t('dashboard.warning', { from: greenDays + 1, yellowDays }),
    },
    {
      color: redColor ?? '#e74c3c',
      label: t('dashboard.stale', { yellowDays }),
    },
    {
      color: '#95a5a6',
      label: t('dashboard.notScouted'),
    },
  ];

  return (
    <div
      data-testid="freshness-legend"
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: '8px',
        padding: '10px 12px',
        background: '#f8f9fa',
        borderRadius: '6px',
        border: '1px solid #dee2e6',
        fontSize: '0.82rem',
      }}
    >
      <span style={{ fontWeight: 600, alignSelf: 'center', marginRight: '4px' }}>
        {t('dashboard.freshness')}
      </span>
      {items.map(item => (
        <span
          key={item.label}
          style={{ display: 'flex', alignItems: 'center', gap: '5px' }}
        >
          <span
            style={{
              display: 'inline-block',
              width: '14px',
              height: '14px',
              borderRadius: '3px',
              background: item.color,
              flexShrink: 0,
            }}
          />
          {item.label}
        </span>
      ))}
    </div>
  );
};

export { FreshnessLegend };
